import { Box } from '@eluve/components';

export const NoAppointmentPlaceholder: React.FC = () => (
  <Box
    center
    className="pointer-events-none size-full pl-[62px] text-border-quaternary md:text-lg"
  >
    <span className="rounded-lg bg-bg-quaternary/30 p-3 text-text-disabled backdrop-blur-sm">
      No appointments found
    </span>
  </Box>
);
